//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    title: String,
    imageUrl: String,
    caption: String,
    link: String
  }
}
